module.exports = __webpack_public_path__ + "static/media/03.696f0468.jpg";